import type { MessageDescriptor } from 'react-intl';
import { defineMessages } from 'react-intl';

type MessageKey =
  | 'uploadTitle'
  | 'uploadDescription'
  | 'imageRightsMessage'
  | 'submitAddImage'
  | 'cancel'
  | 'addImage'
  | 'largeImageError'
  | 'notImageError'
  | 'uploadError'
  | 'emptyFileError'
  | 'uploadSuccess'
  | 'clearButtonLabel';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  uploadTitle: {
    id: 'boxFileRequest.uploadLogoModal.title',
    description: 'Title for the upload header logo modal',
    defaultMessage: 'Add a header logo',
  },
  uploadDescription: {
    id: 'boxFileRequest.uploadLogoModal.description',
    description: 'Description for the upload header logo modal',
    defaultMessage:
      'Header logos look best when they are at least 80px in height, are in png format and have a transparent background. Images must not exceed 1MB.',
  },
  imageRightsMessage: {
    id: 'boxFileRequest.uploadLogoModal.imageRightsMessage',
    description: 'The image rights message',
    defaultMessage:
      'By clicking Add Image, I confirm I have the right to use this image.',
  },
  submitAddImage: {
    id: 'boxFileRequest.uploadLogoModal.submitAddImage',
    description: 'Text for the submit button on the add a header logo modal',
    defaultMessage: 'Add Image',
  },
  cancel: {
    id: 'boxFileRequest.uploadLogoModal.cancel',
    description: 'Text for the cancel button on the upload logo modal',
    defaultMessage: 'Cancel',
  },
  addImage: {
    id: 'boxFileRequest.uploadLogoModal.addImage',
    description: 'Text for the add image button on the upload logo modal',
    defaultMessage: 'Add an image',
  },
  largeImageError: {
    id: 'boxFileRequest.uploadLogoModal.largeImageError',
    description:
      'Error message for upload logo modal when the file is too large',
    defaultMessage:
      'Your file could not be added because is too large. Please select a file under 1MB.',
  },
  notImageError: {
    id: 'boxFileRequest.uploadLogoModal.notImageError',
    description:
      'Error message for upload logo modal when the file is not an image',
    defaultMessage:
      'Your file could not be added because it is not an image. Please select a PNG or JPG image.',
  },
  uploadError: {
    id: 'boxFileRequest.uploadLogoModal.uploadError',
    description:
      'Generic error message shown when there is an error uploading a logo',
    defaultMessage: 'Something went wrong with your upload.',
  },
  emptyFileError: {
    id: 'boxFileRequest.uploadLogoModal.emptyFileError',
    description:
      'Error message displayed in upload modal when a user clicks upload before adding a file',
    defaultMessage: 'Please add an image.',
  },
  uploadSuccess: {
    id: 'boxFileRequest.uploadLogoModal.uploadSuccess',
    description:
      'Success notification message when a logo is uploaded successfully from the upload modal',
    defaultMessage: 'Your file was successfully saved',
  },
  clearButtonLabel: {
    id: 'boxFileRequest.uploadLogoModal.clearButtonLabel',
    description:
      'The aria label for the button that clears the currently selected image in the upload modal',
    defaultMessage: 'Remove selected image',
  },
});

export default messages;
